<template>
  <div class="relative overflow-x-hidden flex-1 px-6 py-6 flex">
    <div class="flex-1">
      <!-- Title Bar -->
      <div
        class="flex items-center justify-between pb-4 border-b border-gray-300"
      >
        <div class="flex items-center space-x-6">
          <h1 class="text-2xl font-semibold text-gray-800">รายชื่อลูกค้า</h1>
          <button
            @click="addCustomer"
            type="button"
            class="
              inline-flex
              items-center
              px-4
              py-2
              border border-transparent
              rounded-md
              shadow-sm
              text-base
              font-semibold
              tracking-wider
              text-white
              bg-cyan-600
              hover:bg-cyan-700
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-cyan-500
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="-ml-1 mr-2 h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"
              />
            </svg>
            เพิ่มลูกค้า
          </button>
        </div>

        <div class="flex items-center space-x-3">
          <SearchWidgetResultsList v-model="search" />
        </div>
      </div>
      <!-- end title bar -->

      <!-- table -->
      <div class="mt-4">
        <AppDataTable
          :isCheckbox="false"
          :options="options"
          :headers="[
            {
              text: 'รหัสลูกค้า',
              class: 'text-left w-28',
              value: 'company_code',
            },
            {
              text: 'ชื่อลูกค้า (ไทย)',
              class: 'text-left',
              value: 'title_th',
            },
            { text: 'ที่อยู่ (ไทย)', class: 'text-left', value: 'address_th' },
            {
              text: 'เริ่มต้นใช้งาน',
              class: 'text-left w-40',
              value: 'activate_start_date',
            },
            {
              text: 'สิ้นสุดการใช้งาน',
              class: 'text-left w-40',
              value: 'activate_end_date',
            },
            {
              text: 'โน๊ต',
              class: 'text-left',
              value: 'note',
            },
            {
              text: 'จัดการ',
              class: 'text-center w-20',
              sortable: false,
              value: 'actions',
            },
          ]"
          :items="filterCustomers.items"
          :loading="loading"
          @sort="sort"
        >
          <template v-slot:title_th="{ item }">
            <button
              @click="
                $router.push({
                  name: 'CustomerDetails',
                  params: { uuid: item.company_uuid },
                })
              "
              type="button"
              class="text-cyan-600 font-medium hover:underline text-left"
            >
              {{ item.title_th }}
            </button>
          </template>
          <template v-slot:activate_start_date="{ item }">
            {{ item.activate_start_date | formatDate }}
          </template>
          <template v-slot:activate_end_date="{ item }">
            {{ item.activate_end_date | formatDate }}
          </template>
          <template v-slot:actions="{ item }">
            <div>
              <button
                @click="
                  $router.push({
                    name: 'CustomerDetails',
                    params: { uuid: item.company_uuid },
                  })
                "
                type="button"
                class="
                  px-1
                  py-1
                  rounded-md
                  hover:bg-gray-200
                  focus:outline-none
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-cyan-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </template>
        </AppDataTable>
      </div>
      <!-- end table -->

      <!-- pagination -->
      <div class="py-4 flex items-center justify-start">
        <AppPagination
          :options="options"
          :startNumberItem="startNumberItem"
          :endNumberItem="endNumberItem"
          :totalItems="filterCustomers.total"
          :isPrevPage="isPrevPage"
          :isNextPage="isNextPage"
          @decreasePage="() => options.page--"
          @increasePage="() => options.page++"
          @itemsPerPageChange="() => (options.page = 1)"
        />
      </div>
      <!-- end pagination -->
    </div>

    <transition
      enter-active-class="transition ease-in-out duration-300"
      enter-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in-out duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        @click="onCloseForm"
        v-if="isOpen"
        class="fixed inset-0 bg-gray-900 bg-opacity-30"
      />
    </transition>

    <!-- form -->
    <AppSlideOverPanel :isOpen="isOpen">
      <FormCustomer
        :currentCustomer="currentCustomer"
        :customer="customer"
        @onClose="onCloseForm"
        @onCancel="onCancelForm"
        @isDataChange="(value) => (isDataFormChange = value)"
      />
    </AppSlideOverPanel>
    <!-- end form -->

    <!-- confirm leave page -->
    <AppConfirmLeavePageModal
      :show="isConfirmLeavePageShow"
      :type="isConfirmLeavePageType"
      :next="isConfirmLeavePageNextFunction"
      @cancel="onCancelConfirmLeavePage"
      @submit="onSubmitConfirmLeavePage"
    >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:title
        >ต้องการปิดใช่ไหม</template
      >
      <template v-if="isConfirmLeavePageType === 'form'" v-slot:message
        >คุณยังไม่ได้บันทึกข้อมูลของคุณ
        คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล ?</template
      >
    </AppConfirmLeavePageModal>
    <!-- end confirm leave page -->
  </div>
</template>

<script>
import moment from 'moment'

import SearchWidgetResultsList from '@/components/SearchWidgetResultsList'
import AppDataTable from '@/components/AppDataTable'
import AppPagination from '@/components/AppPagination'
import AppSlideOverPanel from '@/components/AppSlideOverPanel'
import FormCustomer from '@/components/FormCustomer'
import AppConfirmLeavePageModal from '@/components/AppConfirmLeavePageModal'

export default {
  name: 'CustomerList',

  components: {
    SearchWidgetResultsList,
    AppDataTable,
    AppPagination,
    AppSlideOverPanel,
    FormCustomer,
    AppConfirmLeavePageModal,
  },

  data() {
    return {
      loading: false,
      search: '',
      options: {
        sortBy: 'company_code',
        sortDesc: false,
        itemsPerPage: 10,
        page: 1,
      },
      currentCustomer: {},
      customer: {},
      isOpen: false,
      timeout: null,
      isDataFormChange: false,
      isConfirmLeavePageShow: false,
      isConfirmLeavePageType: '',
      isConfirmLeavePageNextFunction: null,
    }
  },

  filters: {
    formatDate: function (value) {
      return value ? moment(String(value)).format('DD/MM/YYYY') : '-'
    },
  },

  watch: {
    search() {
      this.options.page = 1
    },
  },

  computed: {
    customers() {
      return this.$store.state.customer.customers
    },

    filterCustomers() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let items = this.customers

      if (this.search) {
        items = items.filter((item) => {
          return Object.values({
            company_code: item.company_code,
            title_th: item.title_th,
            address_th: item.address_th || '',
            activate_start_date: item.activate_start_date
              ? moment(item.activate_start_date).format('DD/MM/YYYY')
              : '',
            activate_end_date: item.activate_end_date
              ? moment(item.activate_end_date).format('DD/MM/YYYY')
              : '',
          }).some((s) =>
            s.toString().toLowerCase().includes(this.search.toLowerCase())
          )
        })
      }

      items = items.sort((a, b) => {
        const sortA = a[sortBy] || ''
        const sortB = b[sortBy] || ''

        if (sortDesc) {
          if (sortA < sortB) return 1
          if (sortA > sortB) return -1
          return 0
        } else {
          if (sortA < sortB) return -1
          if (sortA > sortB) return 1
          return 0
        }
      })

      const total = items.length

      if (itemsPerPage > 0) {
        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
      }

      return { items, total }
    },

    startNumberItem() {
      if (this.filterCustomers.total === 0) return 0

      return (this.options.page - 1) * this.options.itemsPerPage + 1
    },

    endNumberItem() {
      const sum = this.options.page * this.options.itemsPerPage
      if (sum < this.filterCustomers.total) return sum

      return this.filterCustomers.total
    },

    isPrevPage() {
      if (this.options.page === 1) return true

      return false
    },

    isNextPage() {
      if (this.filterCustomers.length === 0) return true

      return (
        this.options.page ===
        Math.ceil(this.filterCustomers.total / this.options.itemsPerPage)
      )
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', false)
    this.$store.commit('setBreadcrumbs', [
      { text: 'รายชื่อลูกค้า', routeName: 'CustomerList' },
    ])

    this.fetchDataFromApi()
  },

  methods: {
    onCancelConfirmLeavePage() {
      this.isConfirmLeavePageShow = false
    },

    onSubmitConfirmLeavePage(obj) {
      this.isDataFormChange = false
      if (obj.type === 'form') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.currentCustomer = {}
        this.customer = {}
        return
      }
      if (obj.type === 'page') {
        this.isConfirmLeavePageShow = false
        this.isOpen = false
        this.currentCustomer = {}
        this.customer = {}
        this.timeout = setTimeout(() => {
          obj.next()
        }, 500)
        return
      }
    },

    onCancelForm() {
      this.isDataFormChange = false
      this.isOpen = false
      this.currentCustomer = {}
      this.customer = {}
    },

    onCloseForm() {
      if (this.isDataFormChange) {
        this.isConfirmLeavePageShow = true
        this.isConfirmLeavePageType = 'form'
        return
      }
      this.isOpen = false
      this.currentCustomer = {}
      this.customer = {}
    },

    async fetchDataFromApi() {
      try {
        this.loading = true

        await this.$store.dispatch('customer/fetchCustomers')
      } catch (error) {
        console.log(error.response)
      } finally {
        this.loading = false
      }
    },

    sort(value) {
      if (this.options.sortBy === value) {
        this.options.sortDesc = !this.options.sortDesc
        this.options.page = 1
      } else {
        this.options.sortBy = value
        this.options.sortDesc = false
        this.options.page = 1
      }
    },

    addCustomer() {
      this.isOpen = true
      this.currentCustomer = {}
      this.customer = {}
    },
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDataFormChange) {
      this.isConfirmLeavePageShow = true
      this.isConfirmLeavePageType = 'page'
      this.isConfirmLeavePageNextFunction = next
      return
    }
    if (this.isOpen) {
      this.isOpen = false
      this.timeout = setTimeout(() => {
        next()
      }, 500)
      return
    }

    next()
  },
}
</script>
